import React from "react"
import { Container, Navbar, Row, Col, Image, Accordion } from 'react-bootstrap';
// import ModalPopup from "./modal-popup";
import { Link } from "gatsby";
import LazyLoad from "react-lazy-load";
// import { StaticImage } from "gatsby-plugin-image";
import logo from '../images/logo-footer.svg';
// import Homeramdan from '../images/home-christmas.gif';
// import yelowetaxi from '../images/yelowtaxi-logo-white.svg';
// import yelowexpress from '../images/yelowexpress-logo-white.svg';

const Footer = ({ clonedata, lookdata, alternativedata, migrate }) => {

  // const Homeramdan = '../images/home-ramadan.png';

  const footerlist = [
    {
      title: "Business Type",
      list: [
        {
          list1: "Taxi Dispatch",
          slug: "/taxi-dispatch-software"
        },
        {
          list1: "Airport Transfer",
          slug: "/airport-taxi-transfer-software"
        },
        {
          list1: "Corporate Transport",
          slug: "/corporate-taxi-booking-solution"
        },
        {
          list1: "Limo Dispatch",
          slug: "/limo-dispatch-booking-software"
        },
        {
          list1: "Ride Hailing",
          slug: "/ride-hailing-software"
        },
        {
          list1: "School Bus Transportation",
          slug: "/school-bus-transportation-software"
        },
        {
          list1: "Web Kiosk App for Hotels",
          slug: "/web-kiosk-app-hotels-restaurants-receptions"
        }

      ]
    },
    // {
    //   title: "Food and Beverages",
    //   list: [
    //     {
    //       list1: "Restaurant",
    //       slug: "/restaurant-ordering-and-delivery-solution"
    //     },
    //     {
    //       list1: "Pizza",
    //       slug: "/pizza-ordering-delivery-platform"
    //     },
    //     {
    //       list1: "Cloud kitchen",
    //       slug: "/on-demand-delivery-software-for-cloud-kitchen"
    //     },
    //     {
    //       list1: "Cafes",
    //       slug: "/on-demand-delivery-software-for-cafe-and-coffee-shops"
    //     },
    //     {
    //       list1: "Bakeries",
    //       slug: "/on-demand-delivery-software-for-bakeries"
    //     },
    //     {
    //       list1: "Food Marketplace",
    //       slug: "/on-demand-food-delivery-software-solution"
    //     },
    //   ]
    // },
    // {
    //   title: "Retail",
    //   list: [
    //     {
    //       list1: "Grocery",
    //       slug: "/on-demand-grocery-delivery-software-solution"
    //     },
    //     {
    //       list1: "Meat",
    //       slug: "/on-demand-meat-delivery-software"
    //     },
    //     {
    //       list1: "Milk",
    //       slug: "/online-milk-delivery-software"
    //     },
    //     {
    //       list1: "Medicine",
    //       slug: "/on-demand-medicine-delivery-software-solution"
    //     },
    //     {
    //       list1: "Dark Store",
    //       slug: "/on-demand-delivery-software-for-dark-stores"
    //     },
    //     {
    //       list1: "Materials",
    //       slug: "/on-demand-materials-delivery-software-solution"
    //     },
    //     {
    //       list1: "Home & Kitchen",
    //       slug: "/home-kitchen-appliance-shop-management-software"
    //     },
    //     {
    //       list1: "Beauty & Personal Care",
    //       slug: "/beauty-cosmetic-shop-software"
    //     },
    //   ]
    // },
    {
      title: "Resources",
      list: [
        {
          list1: "Blog",
          slug: "/blog"
        },
        {
          list1: "Product Update",
          slug: "/product-update"
        },
        {
          list1: "Case Studies",
          slug: "/case-studies"
        },
        {
          list1: "Whitepaper",
          slug: "/whitepaper"
        },
        {
          list1: "Webinars",
          slug: "/webinars"
        },
        {
          list1: "Integration",
          slug: "/integrations"
        },
        {
          list1: "Compare",
          slug: "/compare"
        },
        {
          list1: "Alternatives",
          slug: "/alternatives"
        },
        {
          list1: "Glossary",
          slug: "/resources/glossary"
        },
      ]
    },
    {
      title: "Company",
      list: [
        {
          list1: "About Us",
          slug: "/our-story"
        },
        // {
        //   list1: "Our USPs",
        //   slug: "/our-usps"
        // },
        {
          list1: "Why Yelowsoft",
          slug: "/why-yelowsoft"
        },
        {
          list1: "Our Clients",
          slug: "/our-clients"
        },
        {
          list1: "Testimonials",
          slug: "/testimonials"
        },
        {
          list1: "Customer Support",
          slug: "/support-center"
        },
        {
          list1: "Contact Sales",
          slug: "/contact"
        },
        {
          list1: "WhatsApp vs. Yelowsoft",
          slug: "/whatsapp-for-taxi-businesses"
        },
      ]
    },
  ]

  // Ramadan Offer
  // const [isClicked, setIsClicked] = useState(false);

  // const handleClick = () => {
  //   setIsClicked(!isClicked);
  //   navigate("/contact", { state: { fromSection: "Yes" } });
  // };
  // const closemodal = () => {
  //   setIsClicked(!isClicked);
  // };

  return (
    <>

      <footer className="section footer">
        <div className="footer-top py-5">
          <Container>
            <Row className="justify-content-between g-4 gx-sm-50" xs={1} md={2} lg={4} xl={5}>
              {/* <Col>
                <h3 className="h4 text-white mb-4">Popular Features</h3>
                <ul className="list-unstyled footer-menu">
                  <li><Link to="/zone">Zone Pricing</Link></li>
                  <li><Link to="/drivers-subscription">Drivers Subscription</Link></li>
                  <li><Link to="/incentives">Incentives</Link></li>
                  <li><Link to="/smart-algorithm">Smart Algorithm</Link></li>
                  <li><Link to="/reports-and-analytics">Reports Analytics</Link></li>
                </ul>
              </Col> */}
              <Col>
                <h3 className="h4 text-white mb-4">Yelowsoft Inc.</h3>
                <Row as="ul" xs={2} md={1} className="list-unstyled footer-logo-menu g-3">
                  <Col as="li">
                    {/* <LazyLoad offset={150}>
                      <Link to="/taxi-dispatch-software">
                        <Image loading="lazy" className="lazyload" src={yelowetaxi} width={140} height={42} alt="yelowetaxi" />
                      </Link>
                    </LazyLoad> */}
                    <div className="equal-height">
                      <h4 className="h5 text-white mb-3">United States</h4>
                      <p className="opacity-75 mb-2">
                        2035, Sunset Lake Road, Newark, DE 19702
                      </p>
                      <a href="tel:+12108794269">+1 (210) 879-4269</a>
                    </div>
                  </Col>
                  <Col as="li">
                    <div className="equal-height">
                      <h4 className="h5 text-white mb-3">United Kingdom</h4>
                      <p className="opacity-75 mb-2">
                        Level 3, 207 Regent Street, London, W1B 3HH, England
                      </p>
                      <a href="tel:+447488891957">+44 748 889 1957</a>
                    </div>
                    {/* <LazyLoad offset={150}>
                      <Link to="/online-ordering-and-delivery-software">
                        <Image loading="lazy" className="lazyload ms-2" src={yelowexpress} width={140} height={43} alt="yelowexpress" />
                      </Link>
                    </LazyLoad> */}
                  </Col>
                </Row>
              </Col>

              {footerlist.map((item, index) => (
                <Col key={index} className="d-none d-md-block">
                  <h3 className="h4 text-white mb-4">{item.title}</h3>
                  <ul className="list-unstyled footer-menu">
                    {
                      item.list.map((item, index) => (
                        <li key={index}><Link to={item.slug}>{item.list1}</Link></li>
                      ))
                    }
                  </ul>
                </Col>
              ))}
              <Col className="d-block d-md-none mt-0">
                <Accordion defaultActiveKey="0">
                  {footerlist.map((item, index) => (
                    <Accordion.Item key={index} eventKey={index}>
                      <Accordion.Header><h3 className="h4 text-white mb-0">{item.title}</h3></Accordion.Header>
                      <Accordion.Body>
                        <ul className="list-unstyled footer-menu mb-0">
                          {
                            item.list.map((item, index) => (
                              <li key={index}><Link to={item.slug}>{item.list1}</Link></li>
                            ))
                          }
                        </ul>
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="copyrights text-center">
          <Container>
            <div className="social-icon d-flex justify-content-center mb-4">
              <a href="https://www.facebook.com/yelowsoft" aria-label="facebook" rel="noreferrer" target="_blank"><i className="icon zmdi zmdi-facebook"></i></a>
              <a href="https://twitter.com/yelowsoft" aria-label="twitter" rel="noreferrer" target="_blank" style={{ lineHeight: "54px" }}>
                <svg width={30} height={30} aria-hidden="true" focusable="false" data-prefix="fab" data-icon="x-twitter" className="svg-inline--fa fa-x-twitter " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"></path></svg>
              </a>
              <a href="https://www.linkedin.com/company/13587119" aria-label="linkedin" rel="noreferrer" target="_blank"><i className="icon zmdi zmdi-linkedin"></i></a>
              <a href="https://in.pinterest.com/yelowsoft" aria-label="pinterest" rel="noreferrer" target="_blank"><i className="icon zmdi zmdi-pinterest"></i></a>
              <a href="https://www.instagram.com/yelowsoft/?hl=en" aria-label="instagram" rel="noreferrer" target="_blank"><i className="icon zmdi zmdi-instagram"></i></a>
              <a href="https://www.youtube.com/channel/UCKrrVHIZ1EefGKiZ_DPa_8A" aria-label="youtube" rel="noreferrer" target="_blank"><i className="icon zmdi zmdi-youtube"></i></a>
            </div>
            <Navbar.Brand className="mx-auto my-3 d-inline-block">
              <LazyLoad offset={150}>
                <Image loading="lazy" className="lazyload" src={logo} width={154} height={30} alt="logo" />
              </LazyLoad>
            </Navbar.Brand>
            {/* <p className="mb-0">© 2023 Yelowsoft. All Rights Reserved.</p> */}

          </Container>
        </div>
        {
          (clonedata || lookdata || alternativedata || migrate) ?
            <div className="mt-5">
              <Container>
                <div className="other-pages">
                  {
                    lookdata ?
                      <Row className="justify-content-between gx-4" xs={1} sm={2} lg={2}>
                        <Col lg={2}>
                          <h4 className="title">Are you looking for?</h4>
                        </Col>
                        <Col lg={10}>
                          <ul className="other-list">
                            {lookdata?.map((item, index) => (
                              <li key={index}>
                                {item.slug ? <Link to={item.slug}>{item.title}</Link> : item.title}
                              </li>
                            ))}
                          </ul>
                        </Col>
                      </Row> :
                      null
                  }
                  {
                    clonedata ?
                      <Row className="justify-content-between gx-4" xs={1} sm={2} lg={2}>
                        <Col lg={2}>
                          <h4 className="title">Clone APP</h4>
                        </Col>
                        <Col lg={10}>
                          <ul className="other-list">
                            {clonedata?.map((item, index) => (
                              <li key={index}>
                                {item.slug ? <Link to={item.slug}>{item.title}</Link> : item.title}
                              </li>
                            ))}
                          </ul>
                        </Col>
                      </Row> :
                      null
                  }
                  {
                    alternativedata ?
                      <Row className="justify-content-between gx-4" xs={1} sm={2} lg={2}>
                        <Col lg={2}>
                          <h4 className="title">Compare</h4>
                        </Col>
                        <Col lg={10}>
                          <ul className="other-list">
                            {alternativedata?.map((item, index) => (
                              <li key={index}>
                                {item.slug ? <Link to={item.slug}>{item.title}</Link> : item.title}
                              </li>
                            ))}

                          </ul>
                        </Col>
                      </Row> : null
                  }
                  {
                    migrate ?
                      <Row className="justify-content-between gx-4" xs={1} sm={2} lg={2}>
                        <Col lg={2}>
                          <h4 className="title">Migrate</h4>
                        </Col>
                        <Col lg={10}>
                          <ul className="other-list">
                            {migrate?.map((item, index) => (
                              <li key={index}>
                                {item.slug ? <Link to={item.slug}>{item.title}</Link> : item.title}
                              </li>
                            ))}

                          </ul>
                        </Col>
                      </Row> : null
                  }
                </div>
              </Container>
            </div> :
            null
        }
        <Container>
          <div className="copyrights d-sm-flex mt-4 align-items-center text-center">
            <p className="mb-sm-0 mb-2 font-size-14">© 2025 Yelowsoft. All Rights Reserved.</p>
            <ul className="list-unstyled0 footer-menu font-size-10 opacity-75 list-inline d-flex align-items-center ms-auto mb-0 justify-content-center">
              <li><Link to="/terms-of-use">Teams &amp; Conditions</Link></li>
              <li className="mx-2">|</li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            </ul>
          </div>
        </Container>
      </footer >
      {/* <ModalPopup /> */}
      {/* <div className={`grab-offer ${isClicked ? 'clicked' : ''}`} >
        <div>
          <Button variant="" className="btn-close" aria-label="Close" onClick={closemodal}></Button>
        </div>
        <div onClick={handleClick} className="pointer" onKeyDown={handleClick} role="button" tabIndex="0">
          <Image loading="lazy" className="lazyload rounded-3" src={Homeramdan} width={260} height={365} alt="Homechristmas" />
          <StaticImage loading="lazy" className="rounded-3" src={Homeramdan} width={260} height={365} alt="Homeramdan" />
        </div>
      </div> */}
    </>
  )
}

export default Footer;
